/* eslint-disable prettier/prettier */
import api from '@/api'
import store from '@/store'
import axios from 'axios'
import { Toast } from 'vant'

/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

/**
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(
  data,
  isParentKey = 'ParentId',
  isParentValue = '0',
  childrenKey = 'id'
) {
  const parent = data.filter((value) => value[isParentKey] === isParentValue)
  const children = data.filter((value) => value[isParentKey] !== isParentValue)
  const translator = (parent, children) => {
    parent.forEach((parent) => {
      children.forEach((current, index) => {
        if (current[isParentKey] === parent[childrenKey]) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined'
            ? parent.children.push(current)
            : (parent.children = [current])
        }
      })
    })
  }
  translator(parent, children)
  return parent
}

/**
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = []
  data.forEach((item) => {
    const loop = (data) => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
      })
      const child = data.children
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i])
        }
      }
    }
    loop(item)
  })
  return result
}

/**
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
  const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
  let str = ''
  for (let i = 0; i < length; i++) {
    str += num.charAt(Math.floor(Math.random() * num.length))
  }
  return str
}

/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n)
}

/**
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description 数组打乱
 * @param array
 * @returns {*}
 */
export function shuffle(array) {
  let m = array.length,
    t,
    i
  while (m) {
    i = Math.floor(Math.random() * m--)
    t = array[m]
    array[m] = array[i]
    array[i] = t
  }
  return array
}

/**
 * 数组对象根据key,value排序
 * @date 2021-08-20
 * @param {any} array
 * @param {any} key
 * @returns {any} 原数组
 */
export function arrayObjectSort(array, key) {
  array.sort(function (a, b) {
    return a[key] - b[key]
  })
}

/**
 * JS获取树的父节点及祖先节点
 * @date 2021-08-20
 * @param {any} node
 * @param {any} tree
 * @param {any} parentNodes=[]
 * @param {any} index=0
 * @returns {any}
 */
export function treeFindPath(tree, func, path = []) {
  if (!tree) return []
  for (const data of tree) {
    // 这里按照你的需求来存放最后返回的内容吧
    path.push(data)
    if (func(data)) return path
    if (data.children) {
      const findChildren = treeFindPath(data.children, func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/**
 * 上传文件
 * @author hanson.liu
 * @date 2022-1-22
 * @param {any} blob
 * @returns {any}
 */
export const uploadFile = async (blob) => {
  const param = new FormData()
  param.append('formFile', blob)
  const token = store.getters['user/token']
  return axios({
    method: 'POST',
    url: api.UploadFile,
    data: param,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  })
}
//获取设备平台信息
export const detectDevice =  () =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Detect iOS devices (iPhone and iPad)
  if (/iPad|Macintosh/.test(userAgent) && 'ontouchend' in document) {
      return 'iPad';
  }
  if (/iPhone/.test(userAgent) && !window.MSStream) {
      return 'iPhone';
  }
  // Detect Android devices
  if (/android/i.test(userAgent)) {
      return 'Android';
  }
  // Detect HarmonyOS
  if (/HarmonyOS/.test(userAgent)) {
      return 'Harmony';
  }
  // Detect Windows
  if (/windows/i.test(userAgent)) {
      return 'Windows';
  }
  // Detect macOS
  if (/macintosh/i.test(userAgent) && !('ontouchend' in document)) {
      return 'Mac';
  }
  // Default case
  return '/';
 }

/**
 * 通过url获取图片blod 并上传至服务器
 * @author hanson.liu
 * @date 2021-09-27
 * @param {any} imgsrc
 * @returns {any}
 */
export const uploadFromUrl = async (imgsrc) => {
  const blob = await compressImage(imgsrc)
  const param = new FormData()
  param.append('formFile', blob)
  const token = store.getters['user/token']
  return axios({
    method: 'POST',
    url: api.UploadImage,
    data: param,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 压缩
 * @author hanson.liu
 * @date 2021-09-23
 * @param {any} file
 * @returns {any} Promise 小于2M的图片
 */
export const compressImage = (imgsrc) => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    let resultBlob = ''
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = () => {
      let quality = 0.9
      // 调用方法获取blob格式，方法写在下边
      resultBlob = getCompressImage(image, '', quality)
      resolve(resultBlob)
    }
    image.onerror = (e) => {
      reject(e)
    }
    image.src = imgsrc
  })
}

export const getCompressImage = (image, file, quality) => {
  console.log('压缩中，质量：' + quality * 100 + '%')
  let resultBlob = compressUpload(image, file, quality)
  // 压缩至小于2M为止
  if (resultBlob.size > 1024 * 1024 * 2) {
    let q = quality - 0.1
    q <= 0 ? (q = 0.1) : q
    return getCompressImage(image, file, q)
  }
  console.log('压缩完成，质量：' + quality * 100 + '%')
  return resultBlob
}

/* 图片压缩方法-canvas压缩 */
const compressUpload = (image, file, quality) => {
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  //let initSize = image.src.length
  let { width } = image,
    { height } = image
  canvas.width = width
  canvas.height = height
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(image, 0, 0, width, height)
  let compressData = canvas.toDataURL(file.type || 'image/jpeg', quality)

  // 压缩后调用方法进行base64转Blob，方法写在下边
  let blobImg = dataURItoBlob(compressData)
  return blobImg
}

/* base64转Blob对象 */
export const dataURItoBlob = (data) => {
  let byteString
  if (data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(data.split(',')[1])
  } else {
    byteString = unescape(data.split(',')[1])
  }
  let mimeString = data.split(',')[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export const dataURItoBlobv2 = (data, name) => {
  let byteString
  if (data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(data.split(',')[1])
  } else {
    byteString = unescape(data.split(',')[1])
  }
  let mimeString = data.split(',')[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i)
  }
  const bold = new Blob([ia], { type: mimeString })
  return new File([bold], name)
}

export const wxShare = (title, desc, imgUrl) => {
  setTimeout(async () => {
    const tenant = await store.getters['user/getTenant']
    if (!imgUrl) {
      imgUrl =
        'https://wx3.sinaimg.cn/mw1024/9daef013gy1gw9v4ql63dj201i01ia9t.jpg'
      if (tenant.LogoSmall) {
        imgUrl = api.FileHost + tenant.LogoSmall
      }
    }
    // 微信分享start
    const url = location.href.split('#')[0]
    //const url = 'http://wx.tengyuone.com/zeyu/case/'
    store
      .dispatch('user/WechatGetJSSdkInfo', '"' + url + '"')
      .then(({ Data }) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: Data.appId, // 必填，公众号的唯一标识
          timestamp: Data.timestamp, // 必填，生成签名的时间戳
          nonceStr: Data.nonceStr, // 必填，生成签名的随机串
          signature: Data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
        })
        //const tenantName = store.getters['user/getTenant'].TenantName
        //const title = '用户协议'
        //const desc = '请认真阅读并同意协议'

        wx.ready(function () {
          // 分享给朋友
          wx.updateAppMessageShareData({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: () => { },
          })
          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: title, // 分享标题
            //desc: desc, // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: () => { },
          })
        })
      })
  })
}

/**
 * 时间过滤器
 * @date 2021-08-23
 * @param {any} 时间/时间戳
 * @param {any} 转换格式
 * @returns {any} 转换好的时间格式
 */
export const dateFormat = (time, fmt) => {
  if (!time) {
    return
  }
  fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
  let date = new Date(new Date(time).getTime())

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  let dt = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }

  for (let key in dt) {
    if (new RegExp(`(${key})`).test(fmt)) {
      let str = dt[key] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      )
    }
  }

  return fmt
}

/**
 * 复制文本内容功能
 * @param {*} value  参数 文本内容
 */
export const copyText = (value) => {
  document.designMode = 'on'
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', value)
  input.setAttribute('readonly', 'readonly')
  input.select()
  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    // console.log('Copy email command was ' + msg);
    if (!successful) {
      throw new Error('copy failed')
    }
    Toast('复制成功')
  } catch (err) {
    console.log('Oops, unable to copy')
    Toast('复制失败，请重试或手动复制')
  }
  document.body.removeChild(input)
  document.designMode = 'off'
}

export const img2Base64 = (img) => {
  return new Promise((resolve, reject) => {
    var image = new Image()
    image.crossOrigin = '*'
    image.onload = function () {
      var ext = img.src.substring(img.src.lastIndexOf('.') + 1)
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)

      // 这里是不支持跨域的
      var base64 = canvas.toDataURL('image/' + ext)
      resolve(base64)
    }
    image.onerror = function (e) {
      reject(e)
    }
    image.src = img.src
  })
}

export const getTenantCode = () => {
  let pathname = location.pathname.split('/')
  let tenantCode = pathname[1]
  if (!tenantCode) {
    tenantCode = api.defaultTenant
  }
  return tenantCode
}

/**
 * 判断是否是微信内打开
 * @author hanson.liu
 * @date 2022-08-18
 * @returns {boolean}
 */
export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}